<template>
    <div class="goods-detail">
        <div class="goods-detail-main">
            <img :src="detail.cover" :alt="detail.name" class="goods-detail-img">
            <div class="goods-detail-price">
                <img src="../images/coin.png" alt="金币" class="goods-detail-coin">
                {{ detail.showPrice }}
            </div>
        </div>
        <div class="goods-detail-info">
            <p class="goods-detail-info-title">商品描述</p>
            <p class="goods-detail-info-content">{{ detail.desc }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GoodsDetailDialogContent',
    props: {
        detail: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style scoped>
.goods-detail {
    display: inline-flex;
    padding: 16px 16px 18px;
    margin: 28px auto;
    border-bottom: 1px solid rgba(153,37,6,0.41);
    background: url(../images/bg-paw.png) bottom left/82px no-repeat #fff3d3;
    border-radius: 24px;
    box-shadow: 0px 1px 4px 0px rgba(153,37,6,0.41), 0px -4px 4px 0px #ecc596 inset;
}

.goods-detail-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 16px;
}
.goods-detail-img {
    width: 158px;
    height: 170px;
    object-fit: cover;
    border-radius: 30px;
}
.goods-detail-price {
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin-top: 8px;
    line-height: 1;
    font-size: 36px;
    font-weight: bold;
    color: #EA921D;
}
.goods-detail-coin {
    width: 42px;
    height: 42px;
    margin-right: 20px;
}

.goods-detail-info {
    width: 300px;
    border: 2px dashed #e9af43;
    border-radius: 24px;
}
.goods-detail-info-title {
    padding: 8px 12px;
    margin: 0;
    font-size: 28px;
    font-weight: bold;
    color: #CB8552;
    text-align: center;
}
.goods-detail-info-content {
    padding: 8px 12px;
    margin: 0;
    font-size: 24px;
    color: #CB9652;
    text-align: left;
    white-space: pre-wrap;
}
</style>